<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-2 mt-1 px-1">
      <div class="d-flex align-items-center">
        <feather-icon icon="FileTextIcon" size="26" class="text-primary mr-75" />
        <h3 class="mb-0 text-primary font-weight-bolder">
          Planilla Administrativa
        </h3>
      </div>
      <div class="d-flex align-items-center gap-x-2">
        <b-badge variant="light-primary" class="px-1 py-1 d-flex align-items-center" style="font-size: 1rem; border-radius: 8px;">
          <feather-icon icon="UsersIcon" class="mr-50" />
          Registros: {{ totalRows }}
        </b-badge>
      </div>
    </div>

    <filter-slot :filter="filters" :filterPrincipal="filterPrincipal" :paginate="paginate" :showPagination="false"
      class="card-app-design"
      @reload="$refs['ref-table-rrhh-administrative-payroll'].refresh()">
      <template #buttons-filter>
        <div class="d-flex align-items-center justify-content-between flex-wrap my-1 gap-1">
          <div>
            <b-dropdown variant="outline-primary" size="sm" no-caret menu-class="dropdown-menu-luxury shadow-lg border-0" toggle-class="rounded-pill px-1">
              <template #button-content>
                <feather-icon icon="ColumnsIcon" size="16" class="mr-50" />
                <span>Columnas</span>
                <b-badge variant="primary" pill class="ml-50">{{ showFieldsArray.length }}</b-badge>
              </template>
              <div class="custom-scrollbar px-1" style="max-height: 50vh; overflow-y: auto; overflow-x: hidden;">
                <h6 class="dropdown-header px-0 mb-1 text-primary border-bottom pb-50">Visibilidad de Columnas</h6>
                <div v-for="field in showFields" :key="field.key" class="my-50">
                  <b-form-checkbox v-model="showFieldsArray" :value="field.key" class="custom-control-primary text-nowrap">
                    <span class="font-small-3 text-body">{{ field.label == "" ? "Selección" : field.label }}</span>
                  </b-form-checkbox>
                </div>
              </div>
            </b-dropdown>
          </div>

          <div class="d-flex align-items-center gap-x-2 ml-auto">
            <b-button v-if="totalSeleccionados > 0" variant="success" class="btn-app-success shadow-sm"
              @click="aprobarPlanillasSeleccionadas">
              <feather-icon icon="CheckCircleIcon" class="mr-50" />
              APROBAR ({{ totalSeleccionados }})
            </b-button>
          </div>
        </div>
      </template>

      <template #table>
        <b-table ref="ref-table-rrhh-administrative-payroll" :per-page="paginate.perPage"
          :current-page="paginate.currentPage" sticky-header="60vh" small class="position-relative font-small-3" hover
          table-class="text-nowrap" :busy.sync="isBusy" :items="myProvider" :fields="tableFields" :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc" primary-key="id" show-empty :tbody-tr-class="resolveStyleRow">
          <template #table-busy>
            <b-skeleton-table :headers="10" :rows="5" :columns="10" :table-props="{ bordered: true, striped: true }" />
          </template>

          <template #empty="scope">
            <div class="d-flex flex-column justify-content-center align-items-center bg-light-secondary rounded-lg p-5 mt-2" style="height: 300px; border: 2px dashed rgba(115, 103, 240, 0.1);">
              <b-avatar variant="light-primary" size="70" class="mb-2 shadow-sm">
                <feather-icon icon="SearchIcon" size="30" />
              </b-avatar>
              <h4 class="text-secondary font-weight-bolder mb-50">No se encontraron resultados</h4>
              <p class="text-muted font-small-4 mb-0 px-2 text-center">
                No pudimos encontrar registros que coincidan con los filtros aplicados. <br>
                <span class="text-primary cursor-pointer" @click="$refs['ref-table-rrhh-administrative-payroll'].refresh()">Intenta recargar la tabla o ajustar tu búsqueda.</span>
              </p>
            </div>
          </template>

          <template #head(selected)>
            <b-form-checkbox v-model="allSelected" :indeterminate="isIndeterminate" @change="toggleSelectAll" />
          </template>

          <template #cell(selected)="data">
            <b-form-checkbox v-if="data.item.is_ready_to_approve == 1" v-model="selectedItemsMap[data.item.id]"
              @change="toggleRowSelection(data.item)" />
          </template>

          <template #cell(empleado)="data">
            <div class="d-flex align-items-center py-25">
              <b-avatar size="32" :variant="data.item.fecha_cese ? 'light-danger' : 'light-success'" class="mr-1 shadow-sm">
                <feather-icon icon="UserIcon" size="16" />
              </b-avatar>
              <div class="d-flex flex-column">
                <router-link target="_blank" :class="[textLink, 'font-weight-bolder']" :to="{
                  name: 'rrhh-employees-information',
                  params: { id: data.item.id_personal },
                }" style="font-size: 0.95rem;">
                  {{ data.item.empleado | capitalize }}
                </router-link>
                <small class="text-muted d-flex align-items-center">
                  <feather-icon icon="HashIcon" size="10" class="mr-25" />
                  {{ data.item.document_number }}
                </small>
              </div>
            </div>
          </template>

          <template #cell(area)="data">
            <span>
              {{ data.item.area }}
            </span>
          </template>

          <template #cell(fecha_cese)="data">

            <span class="text-danger" style="opacity: 0.6" v-if="data.item.fecha_cese != null"> Trabajador cesado:
              {{ data.item.fecha_cese | prettyDateWithoutTime }} </span>


            <span v-else class="text-primary">
              Activo
            </span>
          </template>

          <template #cell(payment_method)="data">
            <b-badge :variant="data.value === 1 ? 'light-primary' : 'light-info'">
              {{ data.value === 1 ? "Quincenal" : "Mensual" }}
            </b-badge>
          </template>

          <template #cell(tiene_otro_pago)="data">
            <b-badge :variant="data.value === 1 ? 'light-primary' : 'light-warning'">
              {{ data.value === 1 ? "SI" : "NO" }}
            </b-badge>
          </template>

          <template #cell(month)="data">
            <span>
              {{ data.item.month | myGlobal }}
            </span>
          </template>

          <template #cell(document_number)="data">
            <span class=""> {{ data.value }} </span>
          </template>

          <template #cell(type_form)="data">
            <!-- <span> {{ $t(data.item.type_form) }}</span> -->
            <span v-if="data.item.type_form == 'Receipt for fees'" class="ml-1">
              R x H
            </span>
            <span v-else class="ml-1"> PLANILLA</span>
          </template>

          <template #cell(salary_per_month)="data">
            <span class="text-primary"> S/.{{ data.value | currency }} </span>
          </template>

          <template #cell(bonification)="data">
            <span class="text-primary">
              S/.{{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(salary_to_pay)="data">
            <!-- v-b-tooltip.hover.html="salaryToPayDetailTooltip(data.item)" -->
            <span class="text-primary"> S/.{{ data.value | currency }} </span>
          </template>

          <template #cell(salary_per_day)="data">
            <span> S/.{{ data.value | currency }} </span>
          </template>

          <template #cell(worked_days)="data">
            <span style="opacity: 0.8">{{ data.value }}</span>
          </template>

          <template #cell(not_worked_days)="data">
            <span style="opacity: 0.8">{{ data.value }}</span>
          </template>

          <template #cell(pension_name)="data">
            <b-badge v-if="data.item.pension_fund_id != null" variant="light-primary">
              {{ data.value }}
            </b-badge>
            <b-badge v-else variant="light-danger">No Aplica</b-badge>
          </template>

          <template #cell(tipo_comision)="data">
            <span v-if="data.item.pension_fund_id != null"
              :class="data.value === 'flujo' ? 'text-primary' : 'text-info'">
              {{ data.value != null ? data.value.toUpperCase() : " - " }}
            </span>
            <span v-else class="text-danger">-</span>
          </template>

          <template #cell(porcentaje_contribucion)="data">
            <span v-if="data.item.pension_fund_id != null && data.value > 0">% {{ data.value }}</span>
            <span v-else> - </span>
          </template>

          <template #cell(monto_contribucion)="data">
            <span v-if="
              data.item.pension_fund_id != null &&
              data.item.monto_contribucion_total > 0
            " class="text-danger">S/ {{ data.item.monto_contribucion_total | currency }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(porcentaje_seguro)="data">
            <span v-if="data.item.pension_fund_id != null && data.value > 0">% {{ data.value }}</span>
            <span v-else> - </span>
          </template>

          <template #cell(monto_seguro)="data">
            <span v-if="
              data.item.pension_fund_id != null &&
              data.item.monto_seguro_total > 0
            " class="text-danger">S/ {{ data.item.monto_seguro_total | currency }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(porcentaje_comision)="data">
            <span v-if="
              data.item.pension_fund_id != null &&
              data.item.tipo_comision == 'mixto'
            ">
              % {{ data.item.porcentaje_comision_mixto }}
            </span>
            <span v-else-if="
              data.item.pension_fund_id != null &&
              data.item.tipo_comision == 'flujo'
            ">
              % {{ data.value }}
            </span>
            <span v-else> - </span>
          </template>

          <template #cell(monto_comision)="data">
            <span v-if="
              data.item.pension_fund_id != null &&
              data.item.monto_comision_total > 0
            " class="text-danger">S/
              {{ data.item.monto_comision_total | currency }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(total_aportaciones)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(descuento_x_falta)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(descuento_x_tardanza)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(other_discounts)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(bono_quincena)="data">
            <span class="text-primary">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(bono_mensual)="data">
            <span class="text-primary">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(monto_quinta)="data">
            <span class="text-danger">S/ {{ data.value | currencyZero }} </span>
          </template>

          <template #cell(total_discounts)="data">
            <span class="text-danger">
              S/
              {{ data.item.total_discounts | currencyZero }}
            </span>
          </template>

          <template #cell(fortnight_amount)="data">
            <span :class="data.item.payment_method == 1 ? 'text-primary' : 'text-info'
              ">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(monthly_amount)="data">
            <span class="text-primary font-weight-bolder">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <!-- COLS PLANILLA ADICIONAL -->
          <template #cell(or_salary)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>
          <template #cell(or_bonification)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>
          <template #cell(or_monthly_descuento_tardanza)="data">
            <span class="text-primary">
              S/
              {{
                (parseFloat(data.value) +
                  parseFloat(data.item.or_descuento_x_tardanza))
                | currencyZero
              }}
            </span>
          </template>
          <template #cell(or_montlhy_descuento_falta)="data">
            <span class="text-primary">
              S/
              {{
                (parseFloat(data.value) +
                  parseFloat(data.item.or_descuento_x_falta))
                | currencyZero
              }}
            </span>
          </template>
          <template #cell(or_monthly_others_discount)="data">
            <span class="text-primary">
              S/
              {{
                (parseFloat(data.value) +
                  parseFloat(data.item.or_others_discount))
                | currencyZero
              }}
            </span>
          </template>
          <template #cell(or_total_descuento)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>
          <template #cell(or_bono_quincena)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>
          <template #cell(or_bono_mensual)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(or_fortnight_amount)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(or_total_amount)="data">
            <span class="text-primary">
              S/ {{ data.value | currencyZero }}
            </span>
          </template>

          <template #cell(payroll_status)="data">
            <b-badge pill :variant="`${resolveStypeStatus(data.item.status_id)}`" class="px-1 py-50">
              <feather-icon icon="InfoIcon" size="12" class="mr-25" />
              {{
                data.item.payroll_status === "Fortnight Pending"
                  ? "Quincena Pendiente"
                  : data.item.payroll_status === "Fortnight Approved"
                    ? "Quincena Aprobada"
                    : data.item.payroll_status === "Fortnight Paid"
                      ? "Quincena Pagada"
                      : data.item.payroll_status === "Salary Pending"
                        ? "Planilla Pendiente"
                        : data.item.payroll_status === "Salary Approved"
                          ? "Planilla Aprobada"
                          : data.item.payroll_status === "Salary Paid"
                            ? "Planilla Pagada"
                            : "Estado no encontrado"
              }}
            </b-badge>
          </template>

          <template #cell(is_ready_to_approve)="data">
            <b-badge :variant="`light-${data.value == 1 ? 'success' : 'warning'}`">
              {{
                data.value == 1 ? $t("To Approve") : $t("Pending To Calculate")
              }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex align-items-center justify-content-center">
              <b-button v-if="data.item.status_id == 2 || data.item.status_id == 5" 
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="flat-primary" class="btn-icon rounded-circle" size="sm"
                v-b-tooltip.hover.bottom="$t('View Payroll')"
                @click="viewPayroll(data.item)">
                <feather-icon icon="EyeIcon" size="16" />
              </b-button>

              <b-button v-if="[1, 4].includes(data.item.status_id)"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-success" class="btn-icon rounded-circle" size="sm"
                v-b-tooltip.hover.bottom="$t('Approve')"
                @click="approvePayroll(data.item)">
                <feather-icon icon="CheckSquareIcon" size="16" />
              </b-button>

              <b-button v-ripple.400="'rgba(255, 159, 67, 0.15)'"
                variant="flat-warning" class="btn-icon rounded-circle" size="sm"
                v-b-tooltip.hover.bottom="$t('View Tracking')"
                @click="openAdministrativePayrollTracking(data.item)">
                <feather-icon icon="ListIcon" size="16" />
              </b-button>
            </div>
          </template>

          <template #custom-foot>
            <tr class="sticky-data" :class="isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'">
              <td v-for="(field, index) in tableFields" :key="field.key" class="text-center"
                :class="{ 'text-right font-weight-bolder': index === 0 }">
                <!-- Subtotal row -->
                <template v-if="
                  tableFields[index + 1] &&
                  tableFields[index + 1].key === 'fortnight_amount'
                ">
                  Subtotal
                </template>
                <template v-else-if="field.key === 'fortnight_amount'">
                  S/.{{ subtotal_fortnight | currencyZero }}
                </template>
                <template v-else-if="field.key === 'monthly_amount'">
                  S/.{{ subtotal_monthly | currencyZero }}
                </template>
                <template v-else> &nbsp; </template>
              </td>
            </tr>

            <tr class="sticky-data" :class="isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'">
              <td v-for="(field, index) in tableFields" :key="field.key" class="text-center"
                :class="{ 'text-right font-weight-bolder': index === 0 }">
                <!-- Total row -->
                <template v-if="
                  tableFields[index + 1] &&
                  tableFields[index + 1].key === 'fortnight_amount'
                ">
                  Total
                </template>
                <template v-else-if="field.key === 'fortnight_amount'">
                  S/.{{ total_fortnight | currencyZero }}
                </template>
                <template v-else-if="field.key === 'monthly_amount'">
                  S/.{{ total_monthly | currencyZero }}
                </template>
                <template v-else> &nbsp; </template>
              </td>
            </tr>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AdministrativePayrollTracking v-if="showAdministrativePayrollTracking" :payroll="selectedPayroll"
      @hideModal="showAdministrativePayrollTracking = false" />

    <AdministrativePayrollModal v-if="showAdministrativePayrollModal" :selectedPayroll="selectedPayroll"
      :isView="isView" @hideModal="showAdministrativePayrollModal = false" @hideModalWithRefresh="
        showAdministrativePayrollModal = false;
      refreshTable();
      " @approvePayroll="handleApprovePayroll" />

    <PlanillaProcesamientoModal v-if="showPlanillaProcesamientoModal" :modalData="batchData"
      @close="handleClosePlanillaProcesamientoModal" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Fields from "@/views/rrhh/views/payroll/data/administrativePayrollFields.data.js";
import Filters from "@/views/rrhh/views/payroll/data/administrativePayrollFilters.data.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

import AdministrativePayrollTracking from "@/views/rrhh/views/payroll/components/administrative-payroll/AdministrativePayrollTracking.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AdministrativePayrollModal from "@/views/rrhh/views/payroll/components/administrative-payroll/AdministrativePayrollModal.vue";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import AdministrativePayrollService from "@/views/rrhh/views/payroll/services/administrative-payroll.service.js";
import moment from "moment";
import PlanillaProcesamientoModal from "@/views/rrhh/views/payroll/components/administrative-payroll/PlanillaProcesamientoModal.vue";

export default {
  components: {
    FilterSlot,
    AdministrativePayrollTracking,
    ToastificationContent,
    AdministrativePayrollModal,
    PlanillaProcesamientoModal,
  },
  data() {
    return {
      showFieldsArray: [],
      filters: Filters,
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      showAdministrativePayrollTracking: false,
      payrollSelected: {},
      selectedPayroll: {
        id: null,
      },
      showAdministrativePayrollModal: false,
      total_fortnight: 0,
      total_monthly: 0,
      subtotal_fortnight: 0,
      subtotal_monthly: 0,

      selectedItemsMap: {}, // { [id]: true/false }
      allSelected: false,
      items: [], // Almacena los items actuales del provider
      totalRows: 0,
      showPlanillaProcesamientoModal: false,
      batchData: {
        id: null,
        name: null,
        status: null,
        message: null,
        progress: 0,
        total_jobs: 0,
        processed_jobs: 0,
        pending_jobs: 0,
        failed_jobs: 0,
        failed_job_details: [],
        created_at: null,
        finished_at: null,
        finished: false,
      },
      progressInterval: null,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    showFields() {
      return this.fields.filter((item) => item.visible);
    },
    tableFields() {
      return this.fields.filter((item) =>
        this.showFieldsArray.includes(item.key)
      );
    },
    isIndeterminate() {
      const values = Object.values(this.selectedItemsMap);
      return values.some((v) => v) && !this.allSelected;
    },
    totalSeleccionados() {
      return this.getSelectedIds().length;
    },
  },
  created() {
    this.fillYears();
    this.fillMonths();
    this.getAreas();
  },
  mounted() {
    const year = moment().year();
    const month = moment().month() + 1;
    this.filters[0].model = year;
    this.filters[1].model = month;

    this.$nextTick(() => {
      const saved = localStorage.getItem("fields_administrative_payroll_table");

      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed) && parsed.length > 0) {
            this.showFieldsArray = parsed;
            return;
          }
        } catch (e) {
          console.warn("Error parseando localStorage:", e);
        }
      }

      this.showFieldsArray = this.showFields.map((f) => f.key);
    });
  },

  watch: {
    showFieldsArray: {
      handler(val) {
        localStorage.setItem(
          "fields_administrative_payroll_table",
          JSON.stringify(val)
        );
      },
      deep: true,
    },
  },

  methods: {
    handleClosePlanillaProcesamientoModal() {
      this.showPlanillaProcesamientoModal = false;
      this.batchData = {
        id: null,
        name: null,
        status: null,
        message: null,
        progress: 0,
        total_jobs: 0,
        processed_jobs: 0,
        pending_jobs: 0,
        failed_jobs: 0,
        failed_job_details: [],
        created_at: null,
        finished_at: null,
        finished: false,
      };
    },
    async handleApprovePayroll(params) {
      this.showAdministrativePayrollModal = false;

      this.addPreloader();

      try {
        const { data } =
          await AdministrativePayrollService.aprobarPlanillaAdministrativo({
            simular: false,
            planillas: [params],
          });

        const batchId = data.batch_id;

        this.showPlanillaProcesamientoModal = true;

        this.progressInterval = setInterval(async () => {
          try {
            const statusData =
              await AdministrativePayrollService.consultarPlanillaAdministrativo(
                batchId
              );

            if (statusData.type === "success") {
              this.batchData = statusData.data;

              if (statusData.data.finished) {
                clearInterval(this.progressInterval);
                this.showToastSuccess("Proceso completado correctamente");
                this.refreshTable();
              }
            }
          } catch (error) {
            clearInterval(this.progressInterval);
            this.showToastError("Error consultando la planilla");
            console.error(error);
          }
        }, 2000);
      } catch (error) {
        this.showToastError(error.response?.data);
      } finally {
        this.removePreloader();
      }
    },
    toggleSelectAll(value) {
      Object.entries(this.selectedItemsMap).forEach(([id, _]) => {
        const item = this.items?.find((i) => i.id === parseInt(id));
        if (item && item.is_ready_to_approve == 1) {
          this.selectedItemsMap[id] = value;
        } else {
          this.selectedItemsMap[id] = false; // 🚫 asegúrate que los no aprobables queden desmarcados
        }
      });

      this.allSelected = value;
    },

    toggleRowSelection(item) {
      this.$nextTick(() => {
        const selectedValues = Object.entries(this.selectedItemsMap)
          .filter(([id]) => {
            const found = this.items?.find((i) => i.id === parseInt(id));
            return found && found.is_ready_to_approve == 1;
          })
          .map(([_, v]) => v);

        this.allSelected =
          selectedValues.length > 0 && selectedValues.every((v) => v);
      });
    },

    getSelectedIds() {
      return Object.keys(this.selectedItemsMap).filter(
        (id) => this.selectedItemsMap[id]
      );
    },
    async getAreas() {
      try {
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.filters[2].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    fillYears() {
      let years = [];
      let startYear = 2023;
      let currentYear = new Date().getFullYear();
      let endYear = currentYear + 1;

      for (let index = startYear; index <= endYear; index++) {
        years.push({ label: index, id: index });
      }
      this.filters[0].options = years;
    },
    fillMonths() {
      let months = [];
      for (let index = 1; index <= 12; index++) {
        months.push({
          label: this.$t(moment(index, "MM").format("MMMM")),
          id: index,
        });
      }
      this.filters[1].options = months;
    },

    async myProvider(ctx) {
      try {
        this.addPreloader();
        let order = 1;
        if (ctx.sortBy) {
          order = this.resolveSortField(ctx.sortBy);
        }

        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          year: this.filters[0].model,
          month: this.filters[1].model,
          area: this.filters[2].model,
          type: this.filters[3].model,
          pago_adicional: this.filters[4].model,
          contrato: this.filters[5].model,
        };
        const { data } =
          await AdministrativePayrollService.getDataPlanillaMensual(params);

        this.total_fortnight = 0;
        this.total_monthly = 0;
        this.subtotal_fortnight = 0;
        this.subtotal_monthly = 0;

        if (data.data.length) {
          this.total_fortnight = data.data[0].total_fortnight || 0;
          this.total_monthly = data.data[0].total_monthly || 0;
        }

        data.data.forEach((element) => {
          this.subtotal_fortnight += parseFloat(element.fortnight_amount);
          this.subtotal_monthly += parseFloat(element.monthly_amount);
        });

        this.totalRows = data.data.length;

        // 🔁 Reset selección
        this.selectedItemsMap = {};
        this.allSelected = false;

        // Guardamos items en memoria (necesario para toggleSelectAll)
        this.items = data.data;

        // Inicializa el mapa
        data.data.forEach((item) => {
          this.$set(this.selectedItemsMap, item.id, false);
        });

        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    resolveSortField(sortBy) {
      let order = 1;
      switch (sortBy) {
        case "empleado":
          order = 6;
          break;
        case "labor_regimen":
          order = 9;
          break;
        case "type_form":
          order = 14;
          break;
        case "payment_method":
          order = 13;
          break;
        case "salary_per_month":
          order = 19;
          break;
        case "pension_name":
          order = 11;
          break;
        case "tipo_comision":
          order = 31;
          break;
        case "monto_comision":
          order = 35;
          break;
        case "total_aportaciones":
          order = 44;
          break;
        case "descuento_x_falta":
          order = 26;
          break;
        case "descuento_x_tardanza":
          order = 25;
          break;
        case "other_discounts":
          order = 24;
          break;
        case "monto_quinta":
          order = 45;
          break;
        case "total_discounts":
          order = 27;
          break;
        case "fortnight_amount":
          order = 46;
          break;
        case "monthly_amount":
          order = 47;
          break;
        case "or_fortnight_amount":
          order = 39;
          break;
        case "or_total_amount":
          order = 40;
          break;
        case "payroll_status":
          order = 15;
          break;
      }
      return order;
    },

    resolveStyleRow(item, type) {
      if (!item || type !== "row") return "";
      if ([2, 5].includes(item.status_id)) {
        return "table-info";
      }
    },

    getStatusVariant(status) {
      if (status == "Salary Pending" || status == "Fortnight Pending") {
        return "light-secondary";
      } else if (
        status == "Salary Approved" ||
        status == "Fortnight Approved"
      ) {
        return "light-warning";
      }
    },

    datesDetailTooltip(item) {
      return `
        <div class="text-left">
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Days")} </span>
            <span class="ml-3"> ${item.total_days_in_range} </span>
          </div>
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Holidays")} </span>
            <span class="ml-3"> ${item.holidays} </span>
          </div>
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Free Days")} </span>
            <span class="ml-3"> ${item.free_days} </span>
          </div>
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Days to Work")} </span>
            <span class="ml-3"> ${item.total_days_to_work} </span>
          </div>
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Worked Days")} </span>
            <span class="ml-3"> ${item.worked_days} </span>
          </div>
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Not Worked Days")} </span>
           <span class="ml-3">${item.not_worked_days} </span>
          </div>
        </div>
      `;
    },

    salaryToPayDetailTooltip(item) {
      return `
        <div class="text-left">
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Salary")} </span>
            <span class="ml-3"> S/. ${item.salary ?? 0} </span>
          </div>
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Mandatory Contribution")} </span>
            <span class="ml-3"> S/. ${item.total_mandatory_contribution ?? 0
        } </span>
          </div>
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Insurance")} </span>
            <span class="ml-3"> S/. ${item.total_insurance ?? 0} </span>
          </div>
          <div class="d-flex justify-content-between">
            <span> ${this.$t("Discounts")} </span>
            <span class="ml-3"> S/. ${item.total_discounts ?? 0} </span>
          </div>
          <div class="d-flex justify-content-between">
            <span> ${this.$t("To Pay")} </span>
            <span class="ml-3"> S/. ${item.salary_to_pay ?? 0} </span>
          </div>
        </div>
      `;
    },

    openAdministrativePayrollTracking(item) {
      this.selectedPayroll = item;
      this.showAdministrativePayrollTracking = true;
    },

    deletePayroll(item) {
      this.$swal
        .fire({
          title: "¿Está seguro de eliminar la planilla?",
          text: "Esta acción no se puede deshacer.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn btn-outline-danger mr-1",
            cancelButton: "btn btn-danger",
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              this.addPreloader();
              await AdministrativePayrollService.deleteAdministrativePayroll({
                payrollId: item.id,
              });
              this.showToastSuccess("Planilla eliminada correctamente.");
              this.refreshTable();
            } catch (error) {
              this.showToastError(
                error.response?.data ||
                "Error al eliminar la planilla. Inténtelo de nuevo."
              );
            } finally {
              this.removePreloader();
            }
          }
        });
    },

    approvePayroll(item) {
      this.selectedPayroll.id = item.id;
      this.showAdministrativePayrollModal = true;
      this.isView = false;
    },

    viewPayroll(item) {
      this.selectedPayroll.id = item.id;
      this.isView = true;
      this.showAdministrativePayrollModal = true;
    },

    refreshTable() {
      this.$refs["ref-table-rrhh-administrative-payroll"].refresh();
    },

    resolveStypeStatus(status_id) {
      let _style = "light-secondary";
      switch (status_id) {
        case 1:
          _style = "light-secondary";
          break;
        case 2:
          _style = "light-primary";
          break;
        case 3:
          _style = "light-success";
          break;
        case 4:
          _style = "light-secondary";
          break;
        case 5:
          _style = "light-primary";
          break;
        case 6:
          _style = "light-success";
          break;
      }
      return _style;
    },

    async aprobarPlanillasSeleccionadas() {
      const selectedIds = this.getSelectedIds();

      const confirm = await this.showConfirmSwal(
        "¿Desea aprobar las planillas seleccionadas?",
        `Se aprobarán ${selectedIds.length} planilla(s) y se generará(n) caja(s) en Rosymar Soft. Esta acción no se podrá revertir.`,
        {
          confirmButtonText: "Sí, aprobar planillas",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn btn-outline-primary mr-1",
            cancelButton: "btn btn-danger",
          },
        }
      );

      if (!confirm.isConfirmed) return;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Título simplificado para máxima compatibilidad */
h3.text-primary {
  font-weight: 800 !important;
  letter-spacing: 0.5px;
}

.dropdown-menu-luxury {
  min-width: 340px !important;
  max-width: 400px !important;
  padding: 1rem 0.5rem !important;
  border-radius: 12px !important;
}

.card-app-design {
  border-radius: 12px;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(115, 103, 240, 0.08) !important;
  transition: all 0.3s ease-in-out;
  overflow: hidden;

  &:hover {
    box-shadow: 0 8px 25px 0 rgba(115, 103, 240, 0.1) !important;
  }
}

.btn-app-success {
  background: linear-gradient(135deg, #28c76f 0%, #48da89 100%) !important;
  border: none !important;
  font-weight: 600;
}

::v-deep .b-table {
  thead th {
    background-color: rgba(115, 103, 240, 0.03) !important;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    border-bottom: 2px solid rgba(115, 103, 240, 0.08) !important;
    padding: 1rem 0.5rem !important;
  }

  tbody tr {
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(113, 102, 240, 0.04) !important;
      transform: scale(1.001);
    }
  }

  td {
    vertical-align: middle !important;
    padding: 0.75rem 0.5rem !important;
  }
}

.custom-scrollbar {
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(115, 103, 240, 0.2);
    border-radius: 10px;
    &:hover {
      background: rgba(115, 103, 240, 0.4);
    }
  }
}

.sticky-data {
  td {
    font-weight: 700;
    border-top: 2px solid rgba(115, 103, 240, 0.1) !important;
    background-color: rgba(115, 103, 240, 0.02) !important;
  }
}

.dark-layout {
  .card-app-design {
    background-color: #161d31 !important;
    border-color: rgba(255, 255, 255, 0.05) !important;
  }

  .dropdown-menu-luxury {
    background-color: #161d31 !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    .text-body {
      color: #d0d2d6 !important;
    }
    .dropdown-header {
      background-color: transparent !important;
    }
  }

  ::v-deep .b-table {
    thead th {
      background-color: rgba(255, 255, 255, 0.03) !important;
    }
    tbody tr:hover {
      background-color: rgba(255, 255, 255, 0.05) !important;
    }
  }

  .sticky-data td {
    background-color: #1e2846 !important;
    color: #d0d2d6 !important;
  }
}
</style>

<style>
.sticky-data {
  position: sticky;
  bottom: 0;
  z-index: 1000;
}
</style>